import { useNavigate } from "react-router-dom";
import { KODE_STATUS_TYPE } from "../../../../utils/constants/StatusType.constants";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import ErrorIcon from "@mui/icons-material/Error";

export default function MKSpesialCard({ mKSpesial }) {
  const navigate = useNavigate();

  return (
    <button
      key={mKSpesial.judul}
      onClick={() =>
        navigate("/mahasiswa/sidang", {
          state: {
            display: "details",
            mKSpesialId: mKSpesial.id,
            jenisSidang: mKSpesial.jenis_sidang,
          },
        })
      }
      className="w-full grow text-left transition rounded-lg border border-grey-500 shadow hover:scale-105"
    >
      <div
        key={"jenis-sidang"}
        className="p-4 rounded-t-lg bg-gray-300 text-xl"
      >
        <span className="font-bold">{mKSpesial.term}</span> - {mKSpesial.jenis_sidang}
      </div>

      <div className="p-4 rounded-b-lg bg-white flex">
        <div key={"judul"} className="font-semibold flex-1 text-lg">
          {mKSpesial.judul}
        </div>

        <div key={"status"} className="flex-1">
          <p className="font-semibold">Status:</p>
          {mKSpesial.status.kode ? (
            mKSpesial.status.kode === KODE_STATUS_TYPE.SELESAI_MK_SPESIAL ? (
              <CheckCircleIcon className="text-green-500" />
            ) : (
              <HourglassTopIcon className="text-orange-400" />
            )
          ) : (
            <ErrorIcon className="text-red-500" />
          )}
          {mKSpesial.status.pesan}
        </div>
      </div>
    </button>
  );
}
